import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

`;

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 5px;
`;

export const ProfileName = styled.span`
  color: ${props => props.theme.colors.text};
  font-size: 14px;
  margin-left: 5px;
`;

export const UserRole = styled.span`
  color: ${props => props.theme.colors.text};
  font-weight: 400;
  font-size: 12px;
  margin-left: 5px;
`;